export function applyResourceSelection(resources, options = {}) {
    const selected = options.filter === undefined
        ? [...resources]
        : resources.filter(options.filter);
    if (options.sort !== undefined) {
        selected.sort(options.sort);
    }
    return selected;
}
